import {migrationKey, MEDIA} from './defaults';
export * from './defaults';

import {faker} from '@faker-js/faker';

import uuid from 'react-native-uuid';

import {
  UserInfo,
  DocsGeneric,
  DocsGenericArray,
  FolderType,
} from '../../types';

const baseFolder = {
  id: 'folder01',
  title: 'My First Folder',
  isFolder: true,
};

export const createUser = async (): Promise<UserInfo> => {
  const photo = faker.image.cats();
  const name = faker.name.fullName();
  const description = faker.animal.cat();
  const year = '19' + new Date(faker.date.birthdate()).getFullYear();
  const id = uuid.v4().toString();
  const handle =
    '@' + (name + description + year).replace(/[^A-Z0-9]+/gi, '');
  return {
    handle,
    photo,
    name,
    description,
    year,
    id,
    idHash: id,
    userDoc: true,
    version: migrationKey,
    prevVersion: '',
  };
};

export const createNewUser = async (writeItem: any) => {
  try {
    const newUser = await createUser();
    console.info('==== creating temp user ====', newUser);
    await writeItem(newUser);
    return newUser;
  } catch (err) {
    console.error('==== error on creating a new user ====', err);
  }
};

export const doInitialMigration = async (
  writeItem: any,
  getUserData: any,
) => {
  console.info('==== do migration ====');
  try {
    let user = await getUserData();
    console.info('initialMigrationUserCheck', user);
    if (user && user.id) {
      return user;
    }

    if (!user || !user.id) {
      user = await createNewUser(writeItem);
    }

    const userId = user.id;
    await Promise.all([
      writeItem({
        ...baseFolder,
        title: 'Demo',
        id: 'demo',
        folderType: FolderType.media,
        date: new Date().toISOString(),
        userId,
      }),
      ...MEDIA.map(async media =>
        writeItem({
          ...media,
          isMediaNew: true,
          folderId: 'demo',
          date: new Date().valueOf(),
        }),
      ),
    ]);
  } catch (err) {
    console.error('====migration err===', err);
  }
  console.info('==== after migration ====');
};
